function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.364.717c-.557.736-.47 1.79.227 2.423l5.704 5.186-5.704 5.187-.12.12a1.81 1.81 0 00-.002 2.429c.67.737 1.812.791 2.55.121l7.173-6.522.12-.12a1.81 1.81 0 00-.12-2.55L3.018.47l-.13-.107-.022-.017A1.805 1.805 0 00.469.591L.364.717z",
  fill: "#F58220",
  fillRule: "nonzero"
});

function SvgArrowForwardBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgArrowForwardBold;